module.exports = __webpack_public_path__ + "img/blue-jeans.514cc316.png";